export default __webpack_public_path__ + "static/media/35.bd9bd56b.png";